import PropTypes from 'prop-types';
import { useState } from 'react';

import { DefaultSheet, Separator, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import QuickActionsButton from '@/components/headerContainer/QuickActionsButton'
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import { useParams } from '@Components/RouterProvider';
import appStore from 'stores/app';

import { useAllocationStore } from '../store';

import URLGeneratorForm from './URLGeneratorForm';
import { useAllocationActive } from './context';

function AllocationHeading() {
  const { collection: { useLoad, item }, lists: { offers: { useLoad: useLoadOffers, items: offers }, forms: { useLoad: useLoadForms, items: forms } } } = useAllocationStore()
  const { id } = useParams()
  const { active, setActive } = useAllocationActive()

  useLoad(id)
  useLoadOffers()
  useLoadForms()

  return <HeaderContainerForm
    title='Allocations'
    data={{ ...item, createdAt: formatDateTime(item?.created_at), updatedAt: formatDateTime(item?.updated_at) }}
    onCancel={() => history.goBack()}
    className={`${item?.id ? 'border-b-0' : ''} relative`}
  >
    <ActiveForm active={active} onChangeActive={setActive} />
    <Separator orientation='vertical' className='py-4' />
    <DropdownMenu optionsLabel='Options'>
      <DropdownMenuTrigger className='flex items-center gap-1'>
        <QuickActionsButton />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' forceMount>
        <URLGenratorSidebar offers={offers} forms={forms} allocation={item} />
      </DropdownMenuContent>
    </DropdownMenu>
  </HeaderContainerForm>
}

function URLGenratorSidebar({ offers, forms, allocation }) {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(!open)

  return <>
    <DefaultSheet
      title='Allocation URL Generator'
      triggerProps={{ asChild: true }}
      trigger={<DropdownMenuItem onClick={toggle} onSelect={e => e.preventDefault()}>URL Generator</DropdownMenuItem>}
      wrapperProps={{ open, onOpenChange: open => !open && toggle() }}
    >
      <URLGeneratorForm
        open={open}
        allocationData={allocation}
        siteData={appStore.site}
        onCancel={() => setOpen(false)}
        offers={offers}
        forms={forms}
      />
    </DefaultSheet>
  </>
}

AllocationHeading.propTypes = {
  data: PropTypes.any,
};

export default AllocationHeading;
